import { render, staticRenderFns } from "./MelonTV.vue?vue&type=template&id=3926d13b&"
import script from "./MelonTV.vue?vue&type=script&lang=js&"
export * from "./MelonTV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports